import React from 'react';
import Slider from 'react-slick';
import { useSanityData } from '../hooks/useSanityData';
import { urlFor } from '../sanityClient';

function NextArrow({ onClick }) {
  return (
    <button type='button' className='slick-next pull-right slick-arrow d-block mt-5' onClick={onClick}>
      <img src='images/next-arrow.svg' className='img-fluid' alt='arrow' title='arrow' />
    </button>
  );
}
function PrevArrow({ onClick }) {
  return (
    <button type='button' className='slick-prev pull-left slick-arrow d-block mt-5' onClick={onClick}>
      <img src='images/prev-arrow.svg' className='img-fluid' alt='arrow' title='arrow' />
    </button>
  );
}

// Fetches all opinions from Sanity and renders the Opinion-style Slick carousel.
export default function OpinionSlider({ heading, slidesToShow = 6, autoplaySpeed = 2500, filterByShow = '' }) {
  const lang = localStorage.getItem('language') || 'arm';

  const query = `*[_type == "opinion"] | order(_createdAt asc) {
    _id, title, slug, author, aboutShow, coverImage
  }`;
  const { data: opinions, loading } = useSanityData(query);

  const slickerSettings = {
    customPaging: (i) => (i > 14 ? <div /> : <button>{i}</button>),
    infinite: true,
    centerPadding: '6px',
    slidesToShow,
    slidesToScroll: 1,
    speed: 500,
    centerMode: true,
    variableWidth: false,
    centerMargin: '0',
    adaptiveHeight: false,
    autoplay: true,
    dots: true,
    prevArrow: <div />,
    nextArrow: <div />,
    autoplaySpeed,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
          slidesToScroll: 0,
          adaptiveHeight: false,
          dots: true,
          prevArrow: <PrevArrow />,
          nextArrow: <NextArrow />,
        },
      },
    ],
  };

  if (loading || !opinions) return null;

  const filtered = filterByShow
    ? opinions.filter((o) => {
        const about = o.aboutShow ? (o.aboutShow[lang] || o.aboutShow.en || '') : '';
        return about.toLowerCase().includes(filterByShow.toLowerCase());
      })
    : opinions;

  return (
    <section className='main-container main-container-decoration we-play-content we-play-container opinion-content'>
      {heading && (
        <div className='description-banner'>
          <h2 className='title-generic'>{heading[lang] || heading.en}</h2>
        </div>
      )}
      <section className='center-slider m-auto opinion-content'>
        <Slider {...slickerSettings}>
          {filtered.map((o) => {
            const author   = o.author || '';
            const aboutShow = o.aboutShow ? (o.aboutShow[lang] || o.aboutShow.arm || '') : '';
            const slug     = o.slug?.current || o.slug || '';
            const imgSrc   = o.coverImage ? urlFor(o.coverImage).width(300).url() : '';
            return (
              <div className='slide' key={o._id}>
                <div className='slider-title'>
                  <h2>{author}</h2>
                  <p>{aboutShow}</p>
                </div>
                <div className='child-element'>
                  <div className='deco1 animate animate__animated animate__bounce animate__fadeInDown'>
                    <img src='images/decoration1.svg' alt='icon' className='img-fluid' />
                  </div>
                  <a href={`/${slug}`}>
                    <img src={imgSrc} alt={author} className='img-fluid img-no-stretch' />
                  </a>
                  <div className='deco2 animate animate__animated animate__bounce animate__fadeInDown'>
                    <img src='images/decoration2.svg' alt='icon' className='img-fluid' />
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </section>
    </section>
  );
}
